module.exports = __webpack_public_path__ + "media/images/flags/1x1/mhl-2004e82b28677cffb6b30a9071b31476.svg";